import { CLOSE_KYC } from './KYCContstants';

export const closeKYC = () => {
  return {
    type: CLOSE_KYC,
    payload: true,
  }
};